export default __webpack_public_path__ + "static/1144-4fd869771082d913cd756c0a682bfb98.gif";